import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIntercom16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconIntercom16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 14.762 9.8 14H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v11zM13 4v9.734l-2.968-.707L9.917 13H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1M5.302 9.601l.007.006.036.025q.051.036.152.1c.136.085.335.2.583.314.5.232 1.176.454 1.92.454s1.42-.222 1.92-.454a5.4 5.4 0 0 0 .77-.44l.008-.004V9.6a.5.5 0 0 1 .604.797L11 10l.302.399H11.3l-.002.002-.005.003-.015.012-.054.037q-.068.05-.192.127a6 6 0 0 1-.692.374c-.58.268-1.404.546-2.341.546s-1.76-.278-2.34-.546a6.3 6.3 0 0 1-.885-.5l-.054-.038-.015-.012-.005-.003-.002-.002L5 10l-.302.398a.5.5 0 0 1 .604-.797"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIntercom16);
